import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding, withInMemoryScrolling } from '@angular/router';
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";

import { routes } from './app.routes';
import { DialogService } from 'primeng/dynamicdialog';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { HttpClient, provideHttpClient, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MessageService } from 'primeng/api';
import { authInterceptor } from './services/interceptors/auth.interceptor';

function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './i18n/', '.json');
}
export const provideTranslation = () => ({
  defaultLanguage: 'it',
  loader: {
    provide: TranslateLoader,
    useFactory: HttpLoaderFactory,
    deps: [HttpClient],
  },
});

export const appConfig: ApplicationConfig = {
  providers: [
    MessageService,
    DialogService,
    provideHttpClient(
      withInterceptorsFromDi(),
      withInterceptors([ authInterceptor ])
    ),
    provideZoneChangeDetection({ eventCoalescing: true }), 
    importProvidersFrom([TranslateModule.forRoot(provideTranslation())]),
    provideRouter(
      routes,
      withComponentInputBinding(),
      withInMemoryScrolling({
        scrollPositionRestoration: "top",
        anchorScrolling: "enabled",
      }),
    ),
    provideAnimationsAsync(),
  ]
};
